export const CHECKOUT_URL =
  'https://mega-pack-sabiduria-divina.impultienda.ar/checkout'

export const PRICE = '$19.990'
export const TOTAL_VALUE = '$120.000'
export const BONUS_VALUE = '$42.000'
export const TOMOS_VALUE = '$78.000'

export const BRAND = 'CM Digital Pro™'
export const PRODUCT = 'MEGA PACK SABIDURÍA DIVINA™'
export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/u2Zcx1wn1umXxhET76krVU/Imagen_de_Codex_1_sept_2026,_19_42_47.png'

export const heroBullets = [
  '6 Tomos completos',
  '6 Bonos especiales',
  'Método 15 Minutos con la Palabra™',
  'Plan Guiado de 30 Días',
  'Material 100% digital — acceso inmediato',
]

export const proofStats = [
  { value: '15', label: 'Minutos al día' },
  { value: '6', label: 'Tomos completos' },
  { value: '6', label: 'Bonos incluidos' },
  { value: '100%', label: 'Digital y a tu ritmo' },
]

export const testimonials = [
  {
    quote:
      'Durante mucho tiempo intenté leer la Biblia, pero había partes que no entendía. Tener una estructura hizo que mi lectura fuera mucho más ordenada.',
    author: 'María Fernanda López',
    location: 'Córdoba, Argentina',
  },
  {
    quote: 'Aprender a mirar el contexto cambió mi manera de estudiar los pasajes.',
    author: 'Carlos Andrés Ramírez',
    location: 'Mendoza, Argentina',
  },
  {
    quote: 'El método de 15 minutos me resultó sencillo de incorporar a mi rutina.',
    author: 'Laura Beatriz Fernández',
    location: 'Rosario, Argentina',
  },
  {
    quote:
      'Los mapas y las explicaciones me ayudaron a conectar historias que antes leía por separado.',
    author: 'Daniel Alejandro Gómez',
    location: 'Buenos Aires, Argentina',
  },
]

export const TESTIMONIALS_NOTE =
  'Nota para maquetación: los testimonios anteriores son ejemplos ficticios. Sustituir por testimonios auténticos antes de publicar.'

export const painPoints = [
  'No sabés por dónde empezar.',
  'Algunos pasajes te resultan difíciles.',
  'No entendés bien el contexto.',
  'Encontrás personajes y lugares que no sabés ubicar.',
  'Querés aplicar lo que leés, pero no siempre sabés cómo.',
  'Empezás con entusiasmo… y después perdés constancia.',
]

export const objections = [
  'Una guía',
  'Un mapa',
  'Contexto',
  'Un orden',
  'Preguntas para reflexionar',
  'Un método sencillo',
]

export const audience = [
  'Querés empezar a leer la Biblia.',
  'Leés, pero no siempre comprendés.',
  'Te cuesta entender algunos pasajes.',
  'Querés conocer mejor las enseñanzas de Jesús.',
  'Buscás desarrollar constancia.',
  'Querés llevar principios bíblicos a tu vida cotidiana.',
]

export const pillars = [
  {
    title: 'Un mapa claro',
    desc: 'Cómo está organizada la Biblia, sus libros, personajes y acontecimientos principales.',
  },
  {
    title: 'Contexto y orden',
    desc: 'Explicaciones sencillas, mapas y línea del tiempo para entender qué significa cada pasaje.',
  },
  {
    title: 'Un método diario',
    desc: 'Una rutina de aproximadamente 15 minutos que podés incorporar a tu día.',
  },
]

export const method = [
  {
    time: '3 min',
    title: 'Observá',
    desc: '¿Qué dice realmente el pasaje?',
  },
  {
    time: '4 min',
    title: 'Comprendé',
    desc: '¿Qué significa dentro de su contexto?',
  },
  {
    time: '4 min',
    title: 'Reflexioná',
    desc: '¿Qué enseñanza puedo extraer?',
  },
  {
    time: '4 min',
    title: 'Aplicá',
    desc: '¿Qué puedo llevar conmigo hoy?',
  },
]

export const METHOD_FLOW = 'Leer → Comprender → Reflexionar → Aplicar'

export const results = [
  'Saber por dónde empezar.',
  'Comprender mejor el contexto.',
  'Ubicar personajes y acontecimientos.',
  'Conocer las grandes historias bíblicas.',
  'Profundizar en las enseñanzas de Jesús.',
  'Reflexionar sobre lo que leés.',
  'Aplicar principios bíblicos a situaciones cotidianas.',
  'Crear una rutina de aproximadamente 15 minutos.',
]

export const tomos = [
  {
    title: 'La Biblia sin complicaciones™',
    lead: 'Tu mapa para comprender las Escrituras',
    desc: 'Descubrí cómo está organizada la Biblia, sus principales libros, personajes, acontecimientos y por dónde comenzar.',
    includes: [
      'Estructura de la Biblia',
      'Libros principales',
      'Personajes clave',
      'Por dónde empezar',
    ],
    value: '$12.000',
  },
  {
    title: 'Las grandes historias de la Biblia™',
    lead: 'Historias que dejaron enseñanzas para generaciones',
    desc: 'Abraham, José, Moisés, David, Ester, Daniel, Pedro, Pablo y otros personajes explicados de forma sencilla.',
    includes: ['Historia', 'Desafío', 'Enseñanza', 'Aplicación'],
    value: '$12.000',
  },
  {
    title: 'Las enseñanzas de Jesús™',
    lead: 'Principios para la vida cotidiana',
    desc: 'Amor, perdón, fe, humildad, oración, relaciones, propósito, esperanza y más.',
    includes: ['Parábolas explicadas', 'Fe y perdón', 'Oración', 'Propósito'],
    value: '$14.000',
  },
  {
    title: 'Promesas y palabras para cada momento™',
    lead: 'Una guía bíblica para diferentes momentos de la vida',
    desc: 'Miedo, esperanza, decisiones, preocupación, perdón, paciencia, fortaleza, sabiduría y gratitud.',
    includes: ['Pasaje', 'Contexto', 'Reflexión', 'Aplicación'],
    value: '$12.000',
  },
  {
    title: 'Sabiduría bíblica para la vida™',
    lead: 'Principios bíblicos para situaciones reales',
    desc: 'Familia, relaciones, trabajo, dinero, decisiones, carácter, conflictos, propósito y más.',
    includes: ['Familia', 'Trabajo y dinero', 'Decisiones', 'Conflictos'],
    value: '$13.000',
  },
  {
    title: '15 minutos con la Palabra™',
    lead: 'Tu método diario de estudio',
    desc: 'Observá. Comprendé. Reflexioná. Aplicá. Incluye el Plan Guiado de 30 Días para que sepas exactamente cómo empezar.',
    includes: [
      'Método completo',
      'Plan guiado de 30 días',
      'Rutina diaria',
      'Registro de avance',
    ],
    value: '$15.000',
  },
]

export const tomoIncludes = [
  'Contenido organizado paso a paso',
  'Contexto explicado de forma sencilla',
  'Personajes y lugares ubicados',
  'Preguntas para reflexionar',
  'Aplicación práctica',
  'Material descargable',
  'Uso como biblioteca de consulta',
]

export const bonuses = [
  {
    title: '100 Pasajes esenciales™',
    desc: '100 pasajes organizados por temas con contexto y explicación.',
    value: '$8.000',
  },
  {
    title: 'Mapas y línea del tiempo bíblica™',
    desc: 'Visualizá lugares, personajes y acontecimientos de las Escrituras.',
    value: '$8.000',
  },
  {
    title: 'Diario Sabiduría Divina — 30 días™',
    desc: 'Registrá lo que observás, comprendés, reflexionás y aplicás.',
    value: '$7.000',
  },
  {
    title: '30 Oraciones guiadas™',
    desc: 'Oraciones y reflexiones para diferentes momentos de tu vida.',
    value: '$6.000',
  },
  {
    title: 'Diccionario bíblico esencial™',
    desc: 'Comprendé conceptos bíblicos importantes de manera sencilla.',
    value: '$6.000',
  },
  {
    title: '52 Semanas de sabiduría™',
    desc: '52 reflexiones para continuar tu recorrido durante todo el año.',
    value: '$7.000',
  },
]

export const valueStack = [
  { item: '6 Tomos completos', value: '$78.000' },
  { item: '6 Bonos especiales', value: '$42.000' },
  { item: 'Método 15 Minutos con la Palabra™', value: 'Incluido' },
  { item: 'Plan Guiado de 30 Días', value: 'Incluido' },
]

export const changeRows = [
  { sin: 'No sabés por dónde empezar.', con: 'Tenés una ruta clara.' },
  { sin: 'Algunos pasajes te confunden.', con: 'Comprendés mejor el contexto.' },
  { sin: 'Saltás entre libros.', con: 'Tenés un recorrido organizado.' },
  { sin: 'No sabés qué reflexionar.', con: 'Tenés preguntas que te orientan.' },
  { sin: 'Te cuesta aplicar lo leído.', con: 'Tenés un método práctico.' },
  { sin: 'Perdés constancia.', con: 'Tenés una rutina de 15 minutos.' },
]

export const faqs = [
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. Está pensado especialmente para principiantes.',
  },
  {
    q: '¿Cuánto tiempo necesito?',
    a: 'El método principal está diseñado para aproximadamente 15 minutos por sesión.',
  },
  {
    q: '¿Tengo que leer todo en orden?',
    a: 'No. Podés avanzar a tu propio ritmo y utilizar los materiales como biblioteca de consulta.',
  },
  {
    q: '¿Cómo recibo el Mega Pack?',
    a: 'De manera digital después de confirmar tu compra. Podés utilizarlo desde celular, tablet o computadora.',
  },
  {
    q: '¿Qué incluye?',
    a: '6 tomos + 6 bonos + Método 15 Minutos con la Palabra™ + Plan Guiado de 30 Días.',
  },
  {
    q: '¿Puedo imprimirlo?',
    a: 'Los materiales identificados como imprimibles pueden descargarse e imprimirse para uso personal.',
  },
  {
    q: '¿Tiene garantía?',
    a: 'Sí. Contás con 7 días de garantía según las condiciones de compra.',
  },
]

export const withoutSystem = [
  'Seguís leyendo sin una ruta.',
  'Algunos pasajes siguen resultando difíciles.',
  'Te cuesta comprender el contexto.',
  'Empezás y abandonás.',
  'Y volvés a pensar: “Algún día voy a aprender a estudiarla mejor.”',
]

export const withSystem = [
  'Tenés una ruta.',
  'Tenés contexto.',
  'Tenés explicaciones.',
  'Tenés mapas.',
  'Tenés preguntas.',
  'Tenés un diario.',
  'Tenés un plan de 30 días.',
  'Tenés un método de 15 minutos.',
]
